import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import { R as g, T as h, G as y, P as d, S as N, a as j, C as i, I as l, b as p, c as m, d as c, L as f, e as u, f as x, g as b } from "./index.DK0Z0VgS.js";
import * as w from "react";
import { F as v } from "./Check16.D3hXRfGO.js";
import { c as n } from "./index.CxSWpsOB.js";
const R = (e, a) => /* @__PURE__ */ t.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: a, ...e, children: [
  /* @__PURE__ */ t.jsx("path", { fill: "currentColor", d: "M11.104 6.604a.5.5 0 0 0-.708-.708L7 9.293 5.604 7.896a.5.5 0 1 0-.708.708l1.75 1.75a.5.5 0 0 0 .708 0l3.75-3.75Z" }),
  /* @__PURE__ */ t.jsx("path", { fill: "currentColor", d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1ZM2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8Z" })
] }), M = w.forwardRef(R), D = (e, a) => /* @__PURE__ */ t.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: a, ...e, children: /* @__PURE__ */ t.jsx("path", { fill: "currentColor", d: "M6.097 3.146a.5.5 0 0 1 .707 0l4.5 4.5a.5.5 0 0 1 0 .708l-4.5 4.5a.5.5 0 0 1-.707-.708L10.243 8 6.097 3.854a.5.5 0 0 1 0-.708Z" }) }), C = w.forwardRef(D), $ = g, E = h, q = y, H = d, J = N, K = j, S = w.forwardRef(({
  className: e,
  inset: a,
  children: o,
  ...s
}, r) => /* @__PURE__ */ t.jsxs(b, { ref: r, className: n("tw-flex tw-gap-2 tw-cursor-pointer tw-select-none tw-items-center tw-rounded-4 tw-pl-12 tw-pb-8 tw-pt-8 tw-pr-8 tw-body-2-m tw-outline-none data-[state=open]:tw-bg-gray-800 [&_svg]:tw-pointer-events-none [&_svg]:tw-size-16 [&_svg]:tw-shrink-0", a && "tw-pl-8", e), ...s, children: [
  o,
  /* @__PURE__ */ t.jsx(C, { className: "tw-ml-auto" })
] }));
S.displayName = b.displayName;
const k = w.forwardRef(({
  className: e,
  ...a
}, o) => /* @__PURE__ */ t.jsx(x, { ref: o, className: n("tw-z-[1032] tw-min-w-[8rem] tw-overflow-hidden tw-rounded-4 tw-border tw-border-gray-700 tw-bg-brand-black tw-p-8 tw-text-brand-white tw-shadow-lg data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2", e), ...a }));
k.displayName = x.displayName;
const I = w.forwardRef(({
  className: e,
  sideOffset: a = 4,
  ...o
}, s) => /* @__PURE__ */ t.jsx(d, { children: /* @__PURE__ */ t.jsx(i, { ref: s, sideOffset: a, className: n("tw-z-[1032] tw-min-w-[8rem] tw-overflow-hidden tw-rounded-4 tw-border tw-border-gray-700 tw-bg-brand-black tw-p-8 tw-text-brand-white tw-shadow-md data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2", e), ...o }) }));
I.displayName = i.displayName;
const z = w.forwardRef(({
  className: e,
  inset: a,
  ...o
}, s) => /* @__PURE__ */ t.jsx(l, { ref: s, className: n("tw-relative tw-flex tw-select-none tw-items-center tw-gap-2 tw-rounded-4 tw-pl-12 tw-pb-8 tw-pt-8 tw-pr-8 tw-body-2-m tw-outline-none tw-transition-colors data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50 [&_svg]:tw-pointer-events-none [&_svg]:tw-size-4 [&_svg]:tw-shrink-0 hover:tw-bg-gray-800", a && "tw-pl-8", e), ...o }));
z.displayName = l.displayName;
const _ = w.forwardRef(({
  className: e,
  children: a,
  checked: o,
  ...s
}, r) => /* @__PURE__ */ t.jsxs(p, { ref: r, className: n("tw-relative tw-flex tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-body-2-m tw-outline-none tw-transition-colors focus:tw-text-gray-500 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50", e), checked: o, ...s, children: [
  /* @__PURE__ */ t.jsx("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ t.jsx(m, { children: /* @__PURE__ */ t.jsx(v, { className: "tw-h-4 tw-w-4" }) }) }),
  a
] }));
_.displayName = p.displayName;
const G = w.forwardRef(({
  className: e,
  children: a,
  ...o
}, s) => /* @__PURE__ */ t.jsxs(c, { ref: s, className: n("tw-relative tw-flex tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-body-2-m tw-outline-none tw-transition-colors focus:tw-text-gray-500 data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50", e), ...o, children: [
  /* @__PURE__ */ t.jsx("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-[3.5px] tw-w-[3.5px] tw-items-center tw-justify-center", children: /* @__PURE__ */ t.jsx(m, { children: /* @__PURE__ */ t.jsx(M, { className: "tw-h-2 tw-w-2 tw-fill-current" }) }) }),
  a
] }));
G.displayName = c.displayName;
const L = w.forwardRef(({
  className: e,
  inset: a,
  ...o
}, s) => /* @__PURE__ */ t.jsx(f, { ref: s, className: n("tw-px-2 tw-py-[1.5px] tw-body-2-m tw-font-semibold", a && "tw-pl-8", e), ...o }));
L.displayName = f.displayName;
const T = w.forwardRef(({
  className: e,
  ...a
}, o) => /* @__PURE__ */ t.jsx(u, { ref: o, className: n("tw-mx-2 tw-my-12 tw-h-[1px] tw-bg-gray-700", e), ...a }));
T.displayName = u.displayName;
const F = ({
  className: e,
  ...a
}) => /* @__PURE__ */ t.jsx("span", { className: n("tw-ml-auto tw-text-xs tw-tracking-widest tw-opacity-60", e), ...a });
F.displayName = "DropdownMenuShortcut";
export {
  $ as D,
  E as a,
  I as b,
  z as c,
  _ as d,
  G as e,
  L as f,
  T as g,
  F as h,
  q as i,
  H as j,
  J as k,
  k as l,
  S as m,
  K as n
};
//# sourceMappingURL=DropdownMenu.D4InU11_.js.map
